import { render, staticRenderFns } from "./DNDCardsGrid.vue?vue&type=template&id=52bce382&scoped=true"
import script from "./DNDCardsGrid.vue?vue&type=script&lang=js"
export * from "./DNDCardsGrid.vue?vue&type=script&lang=js"
import style0 from "./DNDCardsGrid.vue?vue&type=style&index=0&id=52bce382&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bce382",
  null
  
)

export default component.exports